import { RoutesNames } from './RoutesNames';

export const defaultPagePath = {
  landlord: {
    false: RoutesNames.Dashboard,
  },
  propertyManager: {
    true: RoutesNames.Dashboard,
    false: RoutesNames.Dashboard,
  },
} as const;
